import type {
  CabinetDeviceSessionView,
  CabinetMemberView,
  ListMembersQuery,
  ListMembersResult,
  RevokeMemberAccessRequest,
  RestoreMemberRequest,
  SuspendMemberRequest,
  UpdateMemberAccessRequest,
} from "@planerius/contracts/cabinet-auth"

import { apiRequest } from "./http"

/**
 * Люди с доступом в кабинет (ТЗ 04, Б8–Б10): список, карточка, роль и филиалы, отзыв.
 *
 * Это не сотрудники расписания (directory.api.ts): мастер может работать без входа,
 * бухгалтер — входить и не стоять в журнале. Закрыть доступ и снять человека с графика —
 * два разных действия, и путать их здесь нельзя.
 */

/** Список. Без фильтра по состоянию уволенные не приходят — их смотрят отдельно. */
export function listMembers(
  query: Partial<ListMembersQuery> = {},
  signal?: AbortSignal,
): Promise<ListMembersResult> {
  return apiRequest("/cabinet/members", {
    query: { limit: 100, ...query },
    signal,
  })
}

/** Активные входы человека в этом салоне — «Активные входы» карточки. */
export function listMemberSessions(memberId: string, signal?: AbortSignal): Promise<CabinetDeviceSessionView[]> {
  return apiRequest(`/cabinet/members/${encodeURIComponent(memberId)}/sessions`, { signal })
}

/** Роль и филиалы. Версия обязательна: два управляющих не затрут друг друга молча. */
export function updateMemberAccess(request: UpdateMemberAccessRequest): Promise<CabinetMemberView> {
  return apiRequest("/cabinet/members/access", { method: "POST", body: request })
}

/** Приостановка — отпуск, разбирательство: обратимо, в отличие от закрытия. */
export function suspendMember(request: SuspendMemberRequest): Promise<CabinetMemberView> {
  return apiRequest("/cabinet/members/suspend", { method: "POST", body: request })
}

export function restoreMember(request: RestoreMemberRequest): Promise<CabinetMemberView> {
  return apiRequest("/cabinet/members/restore", { method: "POST", body: request })
}

/**
 * Закрытие доступа при увольнении. Повтор после обрыва связи сервер считает успехом
 * и отвечает карточкой уволенного — экран не покажет ошибку там, где всё сработало.
 */
export function revokeMember(request: RevokeMemberAccessRequest): Promise<CabinetMemberView> {
  return apiRequest("/cabinet/members/revoke", { method: "POST", body: request })
}
